'use client'

import { useEffect, useRef } from 'react'

class ClassWatcher {
  private targetNode: Element
  private classToWatch: string
  private classAddedCallback: () => void
  private classRemovedCallback: () => void
  private observer: MutationObserver
  private lastClassState: boolean

  constructor(
    targetNode: Element,
    classToWatch: string,
    classAddedCallback: () => void,
    classRemovedCallback: () => void
  ) {
    this.targetNode = targetNode
    this.classToWatch = classToWatch
    this.classAddedCallback = classAddedCallback
    this.classRemovedCallback = classRemovedCallback
    this.lastClassState = targetNode.classList.contains(classToWatch)
    this.observer = new MutationObserver(this.mutationCallback)

    this.observe()
  }

  private observe() {
    this.observer.observe(this.targetNode, { attributes: true, attributeFilter: ['class'] })
  }

  public disconnect() {
    this.observer.disconnect()
  }

  private mutationCallback: MutationCallback = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const currentClassState = (mutation.target as Element).classList.contains(this.classToWatch)
        if (this.lastClassState !== currentClassState) {
          this.lastClassState = currentClassState
          if (currentClassState) {
            console.log('Class added')
            this.classAddedCallback()
          } else {
            console.log('Class removed')
            this.classRemovedCallback()
          }
        }
      }
    }
  }
}

type Props = {
  onAdd?: () => void,
  onRemove?: () => void
}

export const WatchDismissClass = ({ onAdd, onRemove }: Props) => {
  const watcherRef = useRef<ClassWatcher | null>(null)

  useEffect(() => {
    const tryWatch = () => {
      const el = document.getElementById('selfbook-sdkwidget-resume')
      if (!el) {
        setTimeout(tryWatch, 500)
        return
      }

      watcherRef.current = new ClassWatcher(
        el,
        'dismiss-btn-slide-in',
        onAdd || (() => {}),
        onRemove || (() => {})
      )
    }

    tryWatch()

    return () => {
      watcherRef.current?.disconnect()
    }
  }, [onAdd, onRemove])

  return null
}